import { render, staticRenderFns } from "./c-pre-release-management.vue?vue&type=template&id=6b3f75ec&scoped=true"
import script from "./c-pre-release-management.vue?vue&type=script&lang=js"
export * from "./c-pre-release-management.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b3f75ec",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6b3f75ec')) {
      api.createRecord('6b3f75ec', component.options)
    } else {
      api.reload('6b3f75ec', component.options)
    }
    module.hot.accept("./c-pre-release-management.vue?vue&type=template&id=6b3f75ec&scoped=true", function () {
      api.rerender('6b3f75ec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/mconfigs/views/pre-release/c-pre-release-management.vue"
export default component.exports